import styles from './ProductSystemsCatalogCellItems.scss';

import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ProductSystemsItems } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ButtonLinkV2 } from 'src/components/Button/ButtonLinkV2';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { useDesktopOrLarge } from 'src/hooks/UseResponsive';
import { useDCS } from 'src/hooks/useDCS';
import { FlatEntry } from 'src/services/cms/flattenContentful';
import { Grid } from '../Grid/Grid';

interface ProductSystemsCatalogCellItemsProps extends React.HTMLAttributes<HTMLDivElement> {
  entry?: FlatEntry<ProductSystemsItems>;
}

export const ProductSystemsCatalogItems: FC<ProductSystemsCatalogCellItemsProps> = ({
  entry,
  style = {},
}) => {
  if (!entry) return null;
  const isDesktopOrLarge = useDesktopOrLarge();
  const { t } = useTranslation();

  const { heading, description, backgroundColorContainer, link, dcsId } = entry;
  // TODO: useDCS hook need to be changed with useProductPricing hook
  const { productsPricings } = useDCS({ productIds: dcsId ? [dcsId] : [] });
  const [productPricings] = productsPricings;
  return (
    <Grid
      item
      xs={12}
      md={9}
      lg={5}
      xl={4}
      style={!isDesktopOrLarge ? { paddingTop: 0 } : undefined}
      data-test="product-catalog-image"
    >
      <div
        className={styles.productSystemsCatalogCellContent}
        style={{ ...style, backgroundColor: backgroundColorContainer || style.backgroundColor }}
      >
        <TextV2
          isMarkdown
          value={heading}
          entry={{ ...entry, field: 'heading' }}
          tagName="h3"
          variant="h3"
          className={styles.productSystemsCatalogCellTitle}
        />
        {productPricings && (
          <div className={styles.productSystemsCatalogCellPricing}>
            <TextV2
              tagName="h3"
              value={t('pricing-detail-table.full-price', { basePrice: productPricings.basePrice.value })}
              variant="h3"
              className={styles.productSystemsCatalogCellPricingTable}
            />
            {productPricings.installmentPlans.IP3 && (
              <TextV2
                tagName="h5"
                value={t('pricing-detail-table.product-catalog-price-info', { monthlyPrice: productPricings.installmentPlans.IP3.value })}
                variant="h5"
                className={styles.productSystemsCatalogCellPricingInstallment}
              />
            )}
          </div>
        )}
        <TextV2
          isMarkdown
          value={description}
          entry={{ ...entry, field: 'description' }}
          tagName="div"
          variant="body"
          className={styles.productSystemsCatalogCellDescription}
        />
        <ButtonLinkV2 entry={link} className={styles.productSystemsCatalogCellButton} />
      </div>
    </Grid>
  );
};
ProductSystemsCatalogItems.displayName = 'ProductSystemsCatalogItems';
